import { FunctionComponent } from "react";
import { connect } from "react-redux";
import { getPictureById } from "../../selectors/pictures.js";
import {
  ColorScheme,
  ImageModuleSettings,
  OverlayModuleSettings,
  Picture,
  StoreState,
  TranslatedModule,
} from "../../types/index.js";
import { getRecursiveOverlayModule } from "../../utils/utils.js";
import CroppedImage from "../CroppedImage.js";
import OverlayModule from "./OverlayModule.js";

interface Props {
  aspectRatio: number | undefined;
  width: number;
  lazyLoad?: boolean;
  sizes: string;
  translatedModule: TranslatedModule<ImageModuleSettings>;
  scheme: ColorScheme;
  pageId: string;
  isSlider: boolean;
  isPreview: boolean;
  showOverlay: boolean;
}

interface StateProps {
  picture: Picture;
  overlayModule: TranslatedModule<OverlayModuleSettings> | undefined;
}

const ImageModule: FunctionComponent<Props & StateProps> = ({
  aspectRatio,
  width,
  translatedModule: { settings },
  picture,
  sizes,
  lazyLoad = true,
  scheme,
  overlayModule,
  pageId,
  isSlider,
  isPreview,
  showOverlay,
}) => (
  <>
    <CroppedImage
      picture={picture}
      aspectRatio={aspectRatio}
      sizes={sizes}
      lazyLoad={lazyLoad}
      width={width}
      detail={settings}
    />
    {showOverlay && overlayModule && (
      <OverlayModule
        isPreview={isPreview}
        isSlider={isSlider}
        translatedModule={overlayModule}
        pageId={pageId}
        scheme={scheme}
      />
    )}
  </>
);

const mapStateToProps = (
  { mediaLibrary, modules }: StoreState,
  {
    translatedModule: {
      settings: { pictureId },
      id,
      translation: { languageId },
    },
    pageId,
  }: Props,
): StateProps => {
  const overlayModule = getRecursiveOverlayModule({
    languageId,
    modules,
    pageId,
    parentId: id,
  });

  return {
    picture: getPictureById(mediaLibrary.pictures, pictureId),
    overlayModule,
  };
};

export default connect(mapStateToProps)(ImageModule);
